module.exports = __webpack_public_path__ + "img/PC_05.45adde0e.jpg";